import React from "react";
import { Divider as Hr } from "semantic-ui-react";

export default function Divider(props) {
  return <Hr {...props} />;
}
